import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VExpansionPanels,
    { attrs: { "data-qa": "club_faq_list", multiple: "" } },
    _vm._l(_setup.faqList, function (faq, index) {
      return _c(
        VExpansionPanel,
        { key: index },
        [
          _c(
            VExpansionPanelHeader,
            {
              staticClass: "text-left justify-space-between",
              attrs: { "expand-icon": "ui-icon-arrow-down" },
            },
            [
              _c("span", { staticClass: "text-body-1" }, [
                _vm._v(_vm._s(faq.title)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(VExpansionPanelContent, { staticClass: "text-body-1" }, [
            _c("span", { staticClass: "text-pre-line" }, [
              _vm._v(_vm._s(faq.description)),
            ]),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }